module.exports = __webpack_public_path__ + "static/media/099.a3c3dc4b.jpg";